import React from 'react';
// Components
import { testimonialsArray } from '../../utils/data/ReviewData';

function ReviewsPageMainContainer() {
  return (
    <main role='main' className='grid w-full h-full overflow-hidden'>
      <section
        id='testimonials'
        className='px-6 mb-16 sm:px-16 lg:px-20 max-w-3xl lg:max-w-7xl mx-auto text-center'
      >
        <div className='grid gap-6 mt-6 lg:grid-cols-3'>
          {testimonialsArray.map((testimonial, index) => (
            <article
              key={index}
              className='grid p-4 border rounded-lg bg-colour3 shadow-md'
            >
              <section className='grid'>
                <h6 className='text-xl font-bold font-newsweekly uppercase'>
                  {testimonial.name}
                </h6>
                <div className='px-4'>
                  <p className='text-sm opacity-75'>{testimonial.date}</p>
                  <p className='mt-2 italic lg:text-xs'>{testimonial.review}</p>
                </div>
              </section>
              <div className='grid items-end pt-3 text-white neon_text'>
                {'★★★★★'}
              </div>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}

export default ReviewsPageMainContainer;
